import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.endsWith("/superadmin/login")) {
      localStorage.removeItem("admin_token");
      window.location.href = "/superadmin/login";
    }
    return Promise.reject(err);
  }
);

export default adminApi;
